module.exports = __webpack_public_path__ + "static/media/donate.26607864.png";